<!-- <ion-header class="ion-no-border" *ngIf="overlayIndex">
  <ion-toolbar>
      <ion-title>{{ 'Login' | translate }}</ion-title>
      <ion-buttons slot="end">
          <ion-button (click)="close()" color="light">
              <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
      </ion-buttons>
  </ion-toolbar>
</ion-header> -->
<ion-content #content scroll-y="false">

  <div class="content-width">
    <div style="height: 10vh"></div>
    <div style="height: 5vh"></div>
    <div style="text-align: center;">
      <img style="max-height: 35px;" [src]="logo" alt="">
    </div>
    <div style="height: 5vh"></div>


    <form *ngIf="form" [formGroup]="form">
      <ion-list class="ion-padding">
        <ion-row>
          <ion-col size="4">
            <ion-item (click)="getCountryCode()">
              <ion-label position="floating">Country</ion-label>
              <ion-input readonly type="tel" formControlName="country_code" name="Country code"></ion-input>
              <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
            </ion-item>
          </ion-col>
          <ion-col size="8">
            <ion-item>
              <ion-label position="floating">Area code + Phone</ion-label>
              <ion-input type="number" inputmode="numeric" formControlName="phone" name="Phone"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item>
          <ion-label position="floating">Password</ion-label>
          <ion-input formControlName="password" name="Password" type="password"></ion-input>
        </ion-item>

        <div style="height: 10px"></div>
        <ion-button type="submit" expand="block" color="primary" (click)="login()" [disabled]="isLoggingIn">
          <span *ngIf="!isLoggingIn">
            <ion-icon name="log-in" class="ion-padding-end"></ion-icon>Log In
          </span>
          <ion-spinner *ngIf="isLoggingIn" name="circular"></ion-spinner>
        </ion-button>
      </ion-list>
    </form>

    <div class="center">
      <div style="height: 15px;"></div>
      Don't have an account yet? <a (click)="navigate('createUser')">Sign up, it's free.</a>
      <div style="height: 15px;"></div>
      <a (click)="navigate('forgot-password')">Forgot password?</a>
    </div>
    <!--
    <div *ngIf="signup" class="ion-text-center">
        <a (click)="navigate('verify')">Already have a code? Verify.</a>
        <br><br>
        <a (click)="doLogin()">Back</a>
    </div> -->

    <!-- <div *ngIf="verify" class="ion-text-center">
        <a (click)="doSignup()">Back</a>
    </div>

    <div *ngIf="forgotPassword" class="ion-text-center">
        <a (click)="doLogin()">Back</a>
    </div> -->
  </div>
</ion-content>